<template>
  <el-scrollbar wrap-class="scrollbar-wrapper">
    <div class="root-logo" @click="$router.push({ name: 'index' })" style="cursor:pointer">
      <img alt="3306" src="../../../assets/images/logo_white.png" />
    </div>
    <menuu :items="items" />
  </el-scrollbar>
</template>

<script>
import Menu from './menu.vue';
import getMenu from '../../../router/menu/index';

export default {
  name: 'sidebar',
  components: {
    // 'sidebar-item': sidebarItem
    menuu: Menu
  },
  data() {
    return {
      items: [],
      roles: [],
      kind: 0
    };
  },
  async mounted() {
    this.items = await getMenu();
  }
};
</script>

<style lang="scss">
.scrollbar-wrapper {
  overflow-x: hidden !important;
}
.el-scrollbar__view {
  height: 100%;
}
.root-logo {
  width: 100%;
  text-align: center;
  padding: 15px 0;
  border-bottom: 1px solid rgb(56, 74, 102);
  & > img {
    width: 80%;
  }
}
.svg-icon {
  margin-right: 12px;
}
</style>
